export default "__VITE_ASSET__BYdE40aX__"